
import React, { Component } from 'react';
import { Container} from "react-bootstrap";
import { Helmet } from "react-helmet";
//import { GetAPI, PostAPI } from "../../../API/APICalling";
import Axios from '../../lib/axios/axiosInstance';
import CustomStore from 'devextreme/data/custom_store';
import DataGrid,  { Column, FilterRow, HeaderFilter, SearchPanel, Sorting, ColumnChooser, Pager, FilterPanel, Button, Editing, MasterDetail, Export, RemoteOperations, Scrolling, Paging, Selection } from 'devextreme-react/data-grid';
import PivotGrid, {FieldChooser, FieldPanel, StateStoring} from 'devextreme-react/pivot-grid';

import DateBox from 'devextreme-react/date-box';
import Select from 'react-select';
//import { getUser } from "../../../Utils/localStorage"
import DropDownBox from 'devextreme-react/drop-down-box';
import TextBox from 'devextreme-react/text-box';
//import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
//const XlsxPopulate = require('xlsx-populate');
//import { jsPDF } from 'jspdf';
//import 'jspdf-autotable';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import * as AuthVerify from '../../lib/common';
import './textbox.css';
//import { withRouter } from "react-router-dom";

import {
  useLocation,
  useNavigate,
  useParams
} from "react-router-dom";
const allowedPageSizes = [10, 20, 50, 100];
const isNotEmpty = (value) => value !== undefined && value !== null && value !== '';



function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}

class QueryReport extends Component {

  state = {
    reportid: null,
    header: {"reportname": "Sales Report"},
    params: [],
    f2: {},
    datasource: [],
    columns : [{ "dataField" : "arnum",
    "caption" : "Customer Name"
  }, 
  { "dataField" : "billaddr1",
    "caption" : "Billing Address"
  }, 
  { "dataField" : "matnum",
    "caption" : "Product Code"
  }, 
  { "dataField" : "qty",
    "caption" : "Qty",
    "dataType": "number"
  }, 
  { "dataField" : "uom",
    "caption" : "UOM"
  }, 
  { "dataField" : "uprice",
    "caption" : "Price",
    "dataType": "number"
  }, 
  {"dataField":"costcenterid",
  "caption":"Cost Center"
  },
  { "dataField" : "catalogid",
    "caption" : "Catalog"
  }, 
  { "dataField" : "amt",
    "caption" : "Amount",
    "dataType": "number"
  }
],
    gridview : true,
    pivotdatasource : null,
  };

  constructor(props) {
    super(props);
    this.dataGridRenderVlt = this.dataGridRenderVlt.bind(this);
  }

  componentDidMount()
  {
    //console.log("AAAAAA");
    //console.log("BBBBBBBBBB1234", this.props.router.location.search.substring(1));
    var reportid = this.props.router.location.search.substring(1);
    //var reportid = "salesheader";
    //console.log("ABABBBB", reportid);
    this.setState({reportid: reportid});
    this.GetReportInfo(reportid);
  }

  

  volunteers(para) { return new CustomStore({
    key: 'value',
    load: (loadOptions) => {
      let params = '?';
      [
        'filter',
        'group',
        'groupSummary',
        'parentIds',
        'requireGroupCount',
        'requireTotalCount',
        'searchExpr',
        'searchOperation',
        'searchValue',
        'select',
        'sort',
        'skip',
        'take',
        'totalSummary',
        'userData'
      ].forEach(function (i) {
        if (i in loadOptions && isNotEmpty(loadOptions[i])) {
          params += `${i}=${JSON.stringify(loadOptions[i])}&`;
        }
      });
      params = params.slice(0, -1);

      var info = {
        reportnum: this.state.reportid,
        paraname: para.paraname,
        params: this.state.params,
        user: AuthVerify.getUser().arnum
     };

      return Axios.post(`/admin/GetParameterDataSource${params}`, info).then(result =>{
        if (result) {     
            return {
                data: result.data.data.data,
                totalCount: result.data.data.totalCount
            }
        }
    });

      // return fetch(API_BASE_URL + `api/Listing/VolunteerListing${params}`)
      //     .then(handleErrors)
      //     .then(response => response.json())
      //     .then(response => {
      //         return {
      //             data: response.data,
      //             totalCount: response.totalCount
      //         };
      //     })
      //     .catch(() => { throw 'Network error' });
    },
    byKey: (key) => { 
      if (key != ''){

      var info = {
        reportnum: this.state.reportid,
        paraname: para.paraname,
        user: AuthVerify.getUser().arnum,
        key: key
     };

    //   return GetAPI(`api/campaign/GetBasicVolunteerInfo?id=${key}`).then(result => {
    //     console.log(result.data[0])
    //     return result.data[0]});

        return Axios.post(`/admin/GetParameterByKey`, info).then(result =>{
          console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!", result);
            return result.data.data;
        });
      }
    } 
  });
}

  GetReportInfo = async (reportid) => {
    var info = {
        reportnum: reportid,
        user: AuthVerify.getUser().arnum
    };

    var result = (await Axios.post(`/admin/GetReportInfo`, info)).data;
    if (result) {          
        const newheader = result.data[0];
        const newparams = result.params;
        const newf2 = result.f2;

        var columns = JSON.parse(newheader.htmlcontent);

        Array.prototype.forEach.call(columns, i => {
          if (i.dataType === "number")
              i.summaryType = "sum";
        });

        this.setState({header: newheader, 
          params: newparams, //f2: newf2, 
          columns: columns});
    }
  }

    submit = async() =>{
        const dataGrid = this.dataGrid.instance;
        dataGrid.refresh();
    }

 /*exportGrid = (e) => {
      if (e.format === 'pdf'){

          const doc = new jsPDF();
          //console.log(dataGridRef.current)
          const dataGrid = this.dataGrid.instance;

          exportDataGridToPdf({
              jsPDFDocument: doc,
              component: dataGrid
          }).then(() => {
              doc.save((this.state.header.filename ? this.state.header.filename : this.state.header.reportname) + '.pdf');
          });
                      
      }
  }

  /*onExporting = async(e) => {
      
          var result = this.state.header.filename;
          if (!result){
            result = this.state.header.reportname;
          }
              const workbook = new Workbook();
              const worksheet = workbook.addWorksheet('Main sheet');
              exportDataGrid({
                  component: e.component,
                  worksheet: worksheet,
                  customizeCell: function(options) {
                      const excelCell = options;
                      excelCell.font = { name: 'Arial', size: 12 };
                      excelCell.alignment = { horizontal: 'left' };
                  } 
              }).then(function() {
                  workbook.xlsx.writeBuffer()
                      .then(function(buffer) {
                        /* XlsxPopulate.fromDataAsync(buffer).then(function (workbook) {
                          workbook.outputAsync({password: "hwn!EX@2022"}).then(function (blob) {
                              saveAs(blob, result + '.xlsx');
                          });
                      }); */
/*
                          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), result + '.xlsx');
                      });
              });
              e.cancel = true;
     
  }*/

    SubmitPivot = async() => {
        const pivotGrid = this.pivotGrid.instance;
        if (pivotGrid.getDataSource().fields().length == 0){
            pivotGrid.option('dataSource.fields', this.state.columns);
        }
            
        var info = {
            reportnum: this.state.reportid,
            params: this.state.params
        };

        var result = (await Axios.post(`/admin/GetQueryReport?reportnum=${this.state.reportid}&empnum=${AuthVerify.getUser().username}`, info)).data;
        if (result) {          
            pivotGrid.option('dataSource.store', result.data.data);
        }
    }

    toggleView = async(e) => {
        this.setState({gridview: e});
    }

    customDataSource = new CustomStore({
        load: (loadOptions) => {
            /* console.log(this.state.params);
            if (this.state.params.length == 0){
                return {
                    data: [],
                    totalCount: 0
                };
            } */

            var info = {
                reportnum: this.state.reportid,
                params: this.state.params
            };
            
            let params = '?';
      
            [
                'filter',
                'group', 
                'groupSummary',
                'parentIds',
                'requireGroupCount',
                'requireTotalCount',
                'searchExpr',
                'searchOperation',
                'searchValue',
                'select',
                'sort',
                'skip',     
                'take',
                'totalSummary', 
                'userData'
            ].forEach(function(i) {
                if(i in loadOptions && isNotEmpty(loadOptions[i])) {
                    params += `${i}=${JSON.stringify(loadOptions[i])}&`;
                }
            });
            params += `reportnum=${this.state.reportid}&empnum=${AuthVerify.getUser().username}`;
            //params = params.slice(0, -1);
            // console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA");
            return Axios.post(`/admin/GetQueryReport${params}`, info).then(result =>{
              // console.log(result);
                if (result.data.data) {     
                    return {
                        data: result.data.data.data,
                        totalCount: result.data.data.totalcount
                    }
                }
                else{
                  return {
                    data: [],
                    totalCount: 0
                  }
                }
            });
        },
      });

      dataGridRenderVlt() {
        return (
          <DataGrid
            //keyExpr="accountid"
            //dataSource={this.volunteers}
            columns={[
              {dataField: "givenname",
              caption: "Given Name"
            },
            {
              dataField: "email",
              caption: "Email"
            }
            ]}
            hoverStateEnabled=
            {true}
            //selectedRowKeys={this.state.gridBoxValue}
            //onSelectionChanged={this.dataGrid_onSelectionChanged}
            height="300">
            <RemoteOperations groupPaging={true} />
            <Selection mode="multiple" />
            <Scrolling mode="infinite" />
            <Paging enabled={true} pageSize={10} />
            <FilterRow visible={true} />
          </DataGrid>
        );
      }


   render() {
    
    const subs = "<Column dataField='email' caption='Email' /> <Column dataField='surname' caption='Surname' /> <Column dataField='readnotification' caption='Read Notification' /> <Column dataField='waistline' caption='Waist Line' /> <Column dataField='dateofbirth' caption='Date of Birth' dataType='date' format='d/M/yyyy' />";


      return ( 

        <section className="main-container col1-layout">
            <Container className="main">
        <div className="page-wrapper" class="tungstyle">
              <Helmet>
                  <title>Query Report</title>
                  <meta name="description" content="Query Report"/>					
              </Helmet>
              {/* Page Content */}
              <div className="content container-fluid">
                {/* Page Header */}
                <div className="page-header">
                <div className="row align-items-center">
                        <div className="col">
                        <h3 className="page-title">&nbsp;&nbsp;Report Analysis / {this.state.header.reportname}</h3>
                        {/* <ul className="breadcrumb">
                            <li className="breadcrumb-item"><a href="/orange/app/main/dashboard">Report</a></li>
                            <li className="breadcrumb-item active">{this.state.header.reportname}</li>
                        </ul> */}
                        </div>

                    <div className="col-auto float-right ml-auto">
                        <div className="view-icons">
                            <a className={"grid-view btn btn-link" + (this.state.gridview == true ? " active" : "")}  onClick={(e) => {this.toggleView(true)}}><i className="fa fa-th" /> Grid View</a>
                            <a className={"list-view btn btn-link" + (this.state.gridview == false ? " active" : "")} onClick={(e) => {this.toggleView(false)}}><i className="fa fa-bars" /> Pivot View</a>
                        </div>
                    </div>
                </div>
                </div>
                {/* /Page Header */}

                <div className="row filter-row">
                
        
                        {this.state.params.map((para, i, ar)=>{

                        if (para.type == "DateTime")
                        return(
                            <div className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3">
                            <div className="form-group row">
                            <label className="col-form-label col-md-10">{para.alias}</label>
                            <div className="col-md-10">
                                <DateBox 
                                    //style={myComponentStyle}
                                    type="date"
                                    defaultValue={para.parareplace}
                                    onValueChanged={(e) => para.parareplace = e.value}
                                    displayFormat="dd/MM/yyyy"
                                />
                            </div>
                            </div>
                            </div>
                        );
                        else if (para.f2 == true)
                        return(
                            <div className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3">
                            <div className="form-group row">
                            <label className="col-form-label col-md-10">{para.alias}</label>
                            <div className="col-md-10">
                                {/* <Select
                                    options={this.state.f2[para.paraname]}
                                    onChange={(e) => para.parareplace = e.value}
                                /> */}

                            <DropDownBox
                                //style={myComponentStyle}
                                value={para.parareplace}
                                valueExpr="value"
                                deferRendering={false}
                                displayExpr="label"
                                placeholder="Select a value..."
                                showClearButton={false}
                                dataSource={this.volunteers(para)}
                                onValueChanged={(e) =>{
                                    const newparams = this.state.params;
                                    if (para.multiselect){
                                      newparams[i].parareplace = e.value || [];
                                    }
                                    else{
                                      newparams[i].parareplace = e.value
                                    }
                                    this.setState({params: newparams});
                                  }}
                                contentRender={() => {return (
                                    <DataGrid
                                    //keyExpr="accountid"
                                    dataSource={this.volunteers(para)}
                                    columns={[   
                                    {
                                        dataField: "label",
                                        caption: "label"
                                    }
                                    ]}
                                    hoverStateEnabled={true}
                                    showColumnHeaders = {false}
                                    onSelectionChanged={(e) =>{
                                        const newparams = this.state.params;
                                        if (para.multiselect){
                                          newparams[i].parareplace = e.selectedRowKeys.length && e.selectedRowKeys || [];
                                        }
                                        else{
                                          newparams[i].parareplace = e.selectedRowKeys.length && e.selectedRowKeys[0];
                                        }
                                        
                                        this.setState({params: newparams});
                                      }}
                                    height="300">
                                    <RemoteOperations groupPaging={true} />
                                    <Selection mode={para.multiselect == true ? "multiple" : "single"} />
                                    <Scrolling mode="infinite" />
                                    <Paging enabled={true} pageSize={10} />
                                    <FilterRow visible={true} />
                                    </DataGrid>
                                );
                                }}
                            />

                            </div>
                            </div>
                            </div>);
                        else if (para.f2 == false)
                        return(
                            <div className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3">
                            <div className="form-group row">
                            <label className="col-form-label col-md-10">{para.alias}</label>
                            <div className="col-md-10">
                                {/* <input 
                                    type="text" 
                                    className="form-control" 
                                    defaultValue={para.parareplace}
                                    onChange={(e) => {para.parareplace = e.target.value}}
                                /> */}
                                <TextBox
                                  value ={para.parareplace}
                                  valueChangeEvent="input"
                                  onValueChange={(e) => {
                                    para.parareplace = e;
                                    var newpara = this.state.params;
                                    this.setState({params: newpara});
                                  }}
                                  />
                            </div>
                            </div>
                            </div>);
                        
                        })
                        

                        }

                    </div>
  
                    <br></br>
                    <br></br>

            {this.state.gridview == true && (
            <div>
              <div className="row filter-row">
              <div className="col-sm-12 col-md-12"> 
                {/* <a className="btn btn-success btn-block" onClick={this.submit}>REFRESH</a>  */}

                <button
                      className="button btn-proceed-checkout"
                      title="Back"
                      style={{
                        marginRight: "10px",
                        background: "#337ab7",
                        border: "0px solid #337ab7",
                        padding: "10px"
                      }}
                      onClick={() => {window.open('/my-account?activeKey=Analysis', "_self")}}
                    >
                      <span>BACK TO ANALYSIS REPORT</span>
                    </button>

                <button
                      className="button btn-proceed-checkout"
                      title="Refresh"
                      style={{
                        marginRight: "10px",
                        background: "#337ab7",
                        border: "0px solid #337ab7",
                        padding: "10px"
                      }}
                      onClick={this.submit}
                    >
                      <span>REFRESH</span>
                    </button>

                    

              
                </div> 
              </div>
            
              <DataGrid id="gridContainer"
                    ref={(ref) => this.dataGrid = ref}
                    dataSource={this.customDataSource}
                    showBorders={true}
                    allowColumnReordering={true}
                    rowAlternationEnabled={true}
                    allowColumnResizing={true}
                    columnResizingMode="widget"
                    height="auto"
                    columnAutoWidth={true}
                    //onExporting ={this.onExporting}
                    //onExporting={this.exportGrid}
                    columns = {this.state.columns}
                    
                    >
                        <RemoteOperations groupPaging={true}/>
                        <Sorting mode="multiple" />
                        <ColumnChooser
                                enabled={true}
                            />
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={allowedPageSizes}
                                showNavigationButtons={true}
                                showInfo={true}
                                infoText="Page #{0}. Total: {1} ({2} items)"
                            />
                            <FilterPanel visible={true} /> 

                    <Export enabled={true} formats={['xlsx']} fileName={this.state.header.filename ? this.state.header.filename : this.state.header.reportname} />

                    <FilterRow visible={true}
                        applyFilter={"auto"}
                    />
                    <HeaderFilter visible={false} />
                    <SearchPanel visible={true}
                        width={240}
                        placeholder="Search..." />
                    
                    
                    </DataGrid>
                </div>
            )}

        {this.state.gridview == false && (
            <div>
              <div className="row filter-row">
              <div className="col-sm-12 col-md-12"> 
                {/* <a className="btn btn-success btn-block" onClick={this.submit}>REFRESH</a>  */}

                <button
                      className="button btn-proceed-checkout"
                      title="Back"
                      style={{
                        marginRight: "10px",
                        background: "#337ab7",
                        border: "0px solid #337ab7",
                        padding: "10px"
                      }}
                      onClick={() => {window.open('/my-account?activeKey=Analysis', "_self")}}
                    >
                      <span>BACK TO ANALYSIS REPORT</span>
                    </button>

                <button
                      className="button btn-proceed-checkout"
                      title="Refresh"
                      style={{
                        marginRight: "10px",
                        background: "#337ab7",
                        border: "0px solid #337ab7",
                        padding: "10px"
                      }}
                      onClick={this.SubmitPivot}
                    >
                      <span>REFRESH</span>
                    </button>

                    

              
                </div> 
              </div>
            
              <PivotGrid
                //id="sales"
                ref={(ref) => this.pivotGrid = ref}
                dataSource={this.pivotdatasource}
                allowSortingBySummary={true}
                allowSorting={true}
                allowFiltering={true}
                allowExpandAll={true}
                height={"auto"}
                showBorders={true}
                onContextMenuPreparing={(e) => {
                  // Filtering off all non-data fields
                  if (e.field && e.field.area == 'data') {
                      // Obtaining the PivotGrid's data source
                      var dataSource = e.component.getDataSource();
           
                      // Implementing a click event handler for the context menu items
                      var changeSummaryType = function (clickedItem) {
                          dataSource.field(e.field.index, {
                              summaryType: clickedItem.itemData.value
                          });
                          dataSource.load();
                      };
           
                      // Declaring an array of summary types to be present in the context menu
                      var items = [
                          { text: 'Sum', value: 'sum', onItemClick: changeSummaryType },
                          { text: 'Avg', value: 'avg', onItemClick: changeSummaryType },
                          { text: 'Min', value: 'min', onItemClick: changeSummaryType },
                          { text: 'Max', value: 'max', onItemClick: changeSummaryType },
                          { text: 'Count', value: 'count', onItemClick: changeSummaryType },
                          // { text: 'Custom', value: 'custom', onItemClick: changeSummaryType },
                      ];
                      
                      items.forEach(i => {e.items.push(i)});
                  }
              }}
                >
                  <StateStoring
              enabled={true}
              type="localStorage"
              storageKey="dx-widget-gallery-pivotgrid-storing"
            />
                    <RemoteOperations/>
                <FieldPanel
                    showColumnFields={true}
                    showDataFields={true}
                    showFilterFields={true}
                    showRowFields={true}
                    allowFieldDragging={true}
                    visible={true}
                />
                <FieldChooser enabled={true} />
              </PivotGrid>
                </div>
            )}

             
                </div>
            </div>

            </Container></section>
      );
   }
}

export default withRouter(QueryReport);
